import { useMemo } from 'react';
import * as React from 'react';
import styled from 'styled-components';

import { DataSourcesIcon } from '../../icons/Icons';
import {
  AthenaLogo,
  BigQueryLogo,
  ClickhouseLogo,
  DatabricksLogo,
  DremioLogo,
  MariaDBLogo,
  MSSQLServerLogo,
  MySQLLogo,
  PostgresLogo,
  RedshiftLogo,
  SnowflakeLogo,
  TrinoLogo
} from '../../icons/IntegrationLogos';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  gap: 7px;
  line-height: initial;
  font-size: ${({ theme }) => theme.fontSize.SMALL};
  font-family: ${({ theme }) => theme.fontFamily.MONO};

  > div,
  > div svg {
    width: 14px;
    height: 14px;
  }
`;

const Icon = styled.div`
  display: flex;

  svg {
    color: ${({ theme }) => theme.appUI.fontColor.MUTED};
  }
`;

interface DataConnectionNameProps {
  name: string;
}

export const DataConnectionName: React.ComponentType<DataConnectionNameProps> =
  React.memo(({ name }) => {
    const logo = useMemo(() => {
      switch (name) {
        case 'Athena':
          return <AthenaLogo />;
        case 'BigQuery':
          return <BigQueryLogo />;
        case 'Clickhouse':
          return <ClickhouseLogo />;
        case 'Databricks':
          return <DatabricksLogo />;
        case 'Dremio':
          return <DremioLogo />;
        case 'MariaDB':
          return <MariaDBLogo />;
        case 'MSSQLServer':
          return <MSSQLServerLogo />;
        case 'MySQL':
          return <MySQLLogo />;
        case 'Postgres':
          return <PostgresLogo />;
        case 'Redshift':
          return <RedshiftLogo />;
        case 'Snowflake':
          return <SnowflakeLogo />;
        case 'Trino':
          return <TrinoLogo />;
        case 'Data warehouse':
          return (
            <Icon>
              <DataSourcesIcon />
            </Icon>
          );
        default:
          return null;
      }
    }, [name]);

    return (
      <Wrapper>
        {logo} {name}
      </Wrapper>
    );
  });
